// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"32":"74211b4b","163":"04f38f93"}[chunkId] + ".js";
};